import React, { useEffect, useState } from "react";
import { Tab, Tabs, Paper, Typography, AppBar } from "@mui/material";
import TabPanel from "../../TabPanel";
import API from "../../../axios/instances/API";
import Basics from "./Basics";
import Content from "./Content";
import Questions from "./Questions";
import styled from "styled-components";
import FunLoader from "../../Loaders/FunLoader";
import Preview from "../../../pages/private/moduleBuilder/Preview";

const ModalWrapper = styled(Paper)`
  padding: 20px;
  width: calc(min(580px, 96%));
  border-radius: 6px;
  min-height: 600px;
  max-height: 90vh;
  text-align: left;
  position: absolute;
  left: 50%;
  top: 50%;
  border: 2px solid black;
  transform: translate(-50%, -50%);
  overflow-y: scroll;
`;

const LaunchTabs = styled(Tabs)`
  .MuiTab-root {
    border-bottom: 2px solid #eee;
    min-height: 26px;
    font-size: 14px;
    margin-right: 8px;
    min-width: 80px;

    @media (max-width: 1100px) {
      min-width: 100px;
    }

    @media (max-width: 550px) {
      min-width: 80px;
    }
  }

  .MuiTab-root.Mui-selected {
    background-color: white;
    border-bottom: 2px solid rgb(51, 122, 183);
    color: black;
  }

  .MuiTab-wrapper {
    font-size: 15px;
    color: black;
    font-weight: 500;

    @media (max-width: 550px) {
      font-size: 12px;
    }
  }
`;

const ReviewAppBar = styled(AppBar)`
  min-width: 300px;
  width: 100%;
  background-color: white;
  color: black;
  min-height: 26px;
  padding: 0px;
  margin: 0px;
  box-shadow: none;
`;

const TabWrapper = styled.div`
  margin-bottom: 16px;
`;

const FlexDiv = styled.div`
  height: 100%;
  min-height: 500px;
  display: flex;
  flex-direction: column;
`;

const LoadingWrapper = styled.div`
  min-height: 558px;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModulePreview = ({
  reviewModalInfo,
  setSnackbarText,
  handleClose,
  isSuggested = false,
  isViewClosed = false,
}) => {
  const [reviewInfo, setReviewInfo] = useState(null);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    // use useEffect in this component instead of swr because the endpoints is different if the mod is
    // || in lib
    // || is a suggested module being reviewed
    // || is a module in marketplace being reviewed

    const getReviewInfo = async () => {
      try {
        if (isSuggested) {
          const { data } = await API.get(
            `dashboard/quiz/pushed/details/?id=${reviewModalInfo.id}`,
          );
          return setReviewInfo(data.quiz);
        }
        if (isViewClosed) {
          const { data } = await API.get(
            `/dashboard/quiz/review/?id=${reviewModalInfo.id}`,
          );
          return setReviewInfo(data);
        }
        const { data } = await API.get(
          `/dashboard/marketplace/quizzes/quiz/?id=${reviewModalInfo.id}`,
        );
        setReviewInfo(data);
      } catch (error) {
        setSnackbarText("Error loading module review info error");
        handleClose();
      }
    };

    getReviewInfo();
  }, []);

  const handleTabChange = (_, newValue) => {
    setTabValue(newValue);
  };

  return (
    <ModalWrapper>
      {!reviewInfo ? (
        <LoadingWrapper>
          <FunLoader />
        </LoadingWrapper>
      ) : (
        <>
          <FlexDiv>
            <TabWrapper>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  marginBottom: 6,
                }}
              >
                <img
                  src={reviewInfo.image}
                  style={{
                    height: 48,
                    width: 48,
                    borderRadius: 6,
                    border: "1px solid #EEEEEE",
                    objectFit: "contain",
                    marginRight: 8,
                    background: "white",
                  }}
                  alt="module"
                />
                <div
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    style={{
                      fontSize: 18,
                      fontWeight: "600",
                      lineHeight: 1.3,
                    }}
                  >
                    {reviewInfo.name}
                  </Typography>
                  {Boolean(reviewModalInfo?.marketplaceParent)}
                  <span
                    style={{
                      lineHeight: 1.3,
                      fontSize: 11,
                      color: "darkgrey",
                      fontWeight: "400",
                    }}
                  >
                    {reviewModalInfo?.marketplaceParent
                      ? `By: ${reviewModalInfo.marketplaceParent}`
                      : ""}
                  </span>
                </div>
              </div>
              <ReviewAppBar position="static">
                <LaunchTabs
                  value={tabValue}
                  onChange={handleTabChange}
                  scrollButtons={false}
                  TabIndicatorProps={{
                    style: { display: "none" },
                  }}
                >
                  <Tab label="Details" />
                  <Tab label="Content" />
                  <Tab label="Questions" />
                </LaunchTabs>
              </ReviewAppBar>
              <TabPanel value={tabValue} index={0}>
                <Basics details={reviewInfo} />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <Content details={reviewInfo} />
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <Questions
                  questions={reviewInfo.questions.questions}
                  minScore={reviewInfo.passScore}
                />
              </TabPanel>
            </TabWrapper>
          </FlexDiv>
          {isViewClosed && (
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 6,
              }}
            >
              <span style={{ fontSize: 11, color: "slategrey" }}>App View</span>
              <Preview id={reviewModalInfo.id} />
            </div>
          )}
        </>
      )}
    </ModalWrapper>
  );
};

export default ModulePreview;
